import { useFetchInvoices } from './useFetchInvoices'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys as invoicesQueryKeys } from './useQueryInvoices'

const collect = () => {
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()
  const { collect: mutationFn } = useFetchInvoices()

  return useMutation({
    mutationFn,
    onMutate: () => {
      cancelQueries([invoicesQueryKeys.all._def])
    },
    onSettled: () => {
      invalidateQueries([invoicesQueryKeys.all._def])
    },
  })
}

const getPdf = () => {
  const { getPdf: mutationFn } = useFetchInvoices()

  return useMutation({
    mutationFn,
  })
}

export const useMutationInvoices = {
  collect,
  getPdf,
}
